export default {
  'printTemplate.tile': '打印模板',
  'printTemplate.paperSetting': '纸张设置',
  'printTemplate.paperSetting.receipt': '小票',
  'printTemplate.paperSetting.label': 'Label',
  'printTemplate.printLayout': '打印布局',
  'printTemplate.printLayout.horizontal': '横向',
  'printTemplate.printLayout.vertical': '纵向',
  'printTemplate.printLayout.table': '表格',
  'printTemplate.printWidget': '打印组件',
  'printTemplate.printWidget.text': '文本',
  'printTemplate.printWidget.orderField': '订单字段',
  'printTemplate.printWidget.logo': 'Logo',
  'printTemplate.printWidget.divider': '分割线',

  'printTemplate.content': '打印模板内容',

  'printTemplate.setting.padding': '间距',
  'printTemplate.setting.padding.left': '左',
  'printTemplate.setting.padding.right': '右',
  'printTemplate.setting.padding.top': '上',
  'printTemplate.setting.padding.bottom': '下',

  'printTemplate.setting.contentAlign': '内容排列',
  'printTemplate.setting.contentAlign.horizontal': '横向内容',
  'printTemplate.setting.contentAlign.vertical': '纵向内容',

  'printTemplate.setting.table': '表格配置',
  'printTemplate.setting.table.addColumn': '新增列',
};
